import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _Promise from 'babel-runtime/core-js/promise';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _getIterator from 'babel-runtime/core-js/get-iterator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Uploader from '@/components/Uploader/index.vue';
import categoryMixin from '@/views/creative/mixin/category.js';
import { validateFrameSequence, validateDragonBones } from '@/views/creative/utils/resource-validator.js';
import { readFileAsDataURL } from '@/utils/fileReader.js';
import CropperDialog from '@pt/components/cropper-dialog/index';
import { uploadFile } from '@/api/common/upload';
import TagCascaderMulti from '@/components/TagCascaderMulti/index.vue';
import AddAudioDialog from './add-audio-dialog.vue';
import { mapMutations, mapState, mapActions } from 'vuex';
import useFileToExchangeResource from '@/views/creative/utils/use-file-to-exchange-resource';
import { fmtSize } from '@com/utils/data-format';
import { assetCallbackModel } from '@/store/creative/asset';
import useAssetToExchangeFile from '@/views/creative/utils/use-asset-to-exchange-file';
import useCommonToExchangeFile from '@/views/creative/utils/use-common-to-exchange-file';
import { assetsList } from '@pt/api/assets';
import { gitZipDataByUrl, gitZipDataByFile } from '@com/utils/zip-file';
import FrameSelectDialog from '@pt/components/frame-select/dialog.vue';
import { getCommonComponentList } from '@/api/common/asset';
import { isXlzZip, isSameImageSizeXlz, getImageListByZip } from '@com/utils/xlz-file';
import { getImageSize } from '@com/image';
import JSZip from 'jszip';
import { sortFileList } from '@ps/workbench/resource-manager/uploader/xlz';
import { getCommonAssetModelInfo } from '@/api/common/asset';
import { isPresetPrefix as _isPresetPrefix } from '@/views/creative/utils/preset-utils';
import useIdToFindResourceList from '@/views/creative/utils/use-id-to-find-resource-list';
import { getJsonModelPath } from '@/views/creative/utils';
import { tabNameList } from '@com/components/resource-manager/config';
import isMaterialWarehouse from '@/common/is-warehouse';

var cookTagIds = function cookTagIds(ids) {
  return ids ? ids.split(',').map(function (item) {
    return Number(item);
  }) : [];
};

export default {
  mixins: [categoryMixin],

  props: {
    category: Object,
    uploading: Boolean,
    basicResource: Object,
    // 只有编辑、更换的操作才会有resource的prop
    resource: {
      type: Object,
      default: function _default() {
        return null;
      }
    },
    showTag: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  components: {
    Uploader: Uploader,
    CropperDialog: CropperDialog,
    AddAudioDialog: AddAudioDialog,
    FrameSelectDialog: FrameSelectDialog
  },

  watch: {
    cropperDialogVisible: function cropperDialogVisible(val) {
      // 只有需要添加标签并且显示弹框的时候才执行后续操作
      this.resetTagForm(val);
    },
    addAudioVisible: function addAudioVisible(val) {
      // 只有需要添加标签并且显示弹框的时候才执行后续操作
      this.resetTagForm(val);
      // 弹框关闭时，置空声音
      if (!val) {
        this.audioResource = '';
      }
    },
    frameSelectDialogVisible: function frameSelectDialogVisible(v) {
      // 隐藏 previewer，保证拖拽事件正常
      // https://confluence.mobvista.com/pages/viewpage.action?pageId=49618006
      var previewer = document.querySelector('.web-previewer-bd');
      previewer && (previewer.style.display = '' + (v ? 'none' : 'block'));
      // 对话框关闭时清理原始 zip 文件引用
      if (!v) {
        this.originalZipFile = null;
      }
    }
  },

  data: function data() {
    return {
      cropperDialogVisible: false,
      cropper: {},
      model: {
        tagIds: []
      },
      addAudioVisible: false,
      audioResource: '',
      frameSelectDialogVisible: false,
      currentFrame: [], // 序列帧图片列表
      cropperFrames: [], // 待裁剪的帧图片
      cropperTitle: {},
      originalZipFile: null // 原始上传的 zip 文件
    };
  },


  computed: _extends({}, mapState({
    currentResource: function currentResource(state) {
      return state.creative.template.currentResource;
    },
    resourceManagersDialog: function resourceManagersDialog(state) {
      return state.creative.asset.resourceManagersDialog;
    },
    assetsDialog: function assetsDialog(state) {
      return state.creative.asset.assetsDialog;
    },
    template: function template(state) {
      return state.creative.template;
    },
    templateConfig: function templateConfig(state) {
      return state.creative.template.templateConfig;
    }
  }), {
    resourceList: function resourceList() {
      if (this.templateConfig && this.category) {
        var list = useIdToFindResourceList({
          resource: this.templateConfig.resource,
          id: this.category.id
        });
        return list;
      }
      return [];
    },
    resourceMetaData: function resourceMetaData() {
      return this.basicResource.extra || null;
    },
    fileExt: function fileExt() {
      // 视频强制要求是 mp4，即便素材包本身的不是 mp4 格式
      if (this.category.file_type === 'video') {
        return 'MP4';
      } else if (this.isImage) {
        // 图片不限制格式  图片经过裁剪后会处理成坑位所需要的格式
        return 'png,jpeg,jpg';
      }
      return this.category.file_ext || '';
    },
    uploader: function uploader() {
      var data = {};
      if (this.isZip) data.unzip = 1;
      if (this.isVideo) {
        // 如果项目中的视频文件是 ts 格式，则需要转换成 ts 格式
        if (this.category.file_ext === 'ts') {
          data.transcode_format = 'ts';
        }
        data.an = 1; // 1代表消声音，默认都需要消除声音，因为直接播放视频音频在部分设备上会存在杂音的现象
      }
      return {
        data: data,
        accept: '.' + this.fileExt.toLowerCase().split(',').join(',.'),
        onChange: this.onChange,
        onSuccess: this.onSuccess,
        onError: this.onError,
        beforeUpload: this.beforeUpload,
        showFileList: false,
        multiple: false,
        disabled: this.disabled
      };
    },
    formItemList: function formItemList() {
      return [{
        prop: 'tagIds',
        component: TagCascaderMulti,
        rules: [{
          required: true,
          message: this.$t('playTurbo.custom.resourceUploader.tagPlaceholder'),
          trigger: 'change'
        }],
        params: {
          referenceAttrs: {
            style: 'width: 100%'
          },
          params: {
            type: this.category.res_type
          }
        }
      }];
    },
    baseResourcePreviewUrls: function baseResourcePreviewUrls() {
      return _.get(this.basicResource, 'preview_urls_for_live_preview') || [];
    },
    baseResourceFileName: function baseResourceFileName() {
      return _.get(this.basicResource, 'file_name') || '';
    },
    basicResourcePreviewExtras: function basicResourcePreviewExtras() {
      return (_.get(this.basicResource, 'preview_extras') || []).map(function (item) {
        try {
          return JSON.parse(item);
        } catch (err) {
          console.log(err);
          return '';
        }
      }).filter(function (item) {
        return !_.isEmpty(item);
      });
    },
    fileMetaData: function fileMetaData() {
      if (this.isFrameSequence || this.isDragonBones) {
        return this.basicResourcePreviewExtras[0];
      }
      if (!this.basicResource || !this.basicResource.extra) return null;
      return this.basicResource.extra;
    },
    fileSizeText: function fileSizeText() {
      var key = 'playTurbo.custom.resourceDialog';
      if (this.category.file_type === 'video') {
        return '' + this.$t(key + '.fileUpload.video');
      }
      if (this.isFrameSequence) {
        return '' + this.$t(key + '.fileUpload.frameSequence');
      }
      if (this.isDragonBones) {
        return '' + this.$t(key + '.fileUpload.dragonBones');
      }
      if (this.isModel) {
        return '' + this.$t(key + '.fileUpload.model');
      }
      return '' + this.$t(key + '.fileUpload.default');
    },
    fileSize: function fileSize() {
      if ((this.isFrameSequence || this.isDragonBones) && !_.isEmpty(this.basicResourcePreviewExtras)) {
        return fmtSize(this.basicResourcePreviewExtras.map(function (item) {
          return item.file_size;
        }).reduce(function (a, b) {
          return a + b;
        })) + '，';
      }
      return (_.get(this.fileMetaData, 'file_size') ? fmtSize(this.fileMetaData.file_size) : '') + '\uFF0C';
    },


    // 当前视频、音频和图片允许打开资产库弹框
    assetSupportType: function assetSupportType() {
      return this.isAudio || this.isImage || this.isVideo || this.isFrameSequence || this.isModel;
    },
    fileInfo: function fileInfo() {
      var fileExt = this.$t('playTurbo.custom.resourceDialog.uploadRuleLabel') + (this.isVideo ? this.$t('playTurbo.custom.resourceDialog.video.format') : this.fileExt.toUpperCase());
      var fileSize = this.fileSize && this.fileSizeText && this.$t('playTurbo.custom.resourceDialog.fileUpload.label') + this.fileSizeText;
      var imageInfo = [this.$t('playTurbo.custom.resourceDialog.imageSize') + this.fileMetaData.width + '*' + this.fileMetaData.height, fileExt, fileSize];

      var videoInfo = [fileExt, fileSize];
      var audioInfo = [fileExt, fileSize];
      var seqframeInfo = [fileExt, fileSize];
      var modelInfo = [this.$t('playTurbo.custom.resourceDialog.model.label') + this.$t('playTurbo.custom.resourceDialog.model.format'), fileSize];
      if (this.isImage) {
        return imageInfo;
      } else if (this.isVideo) {
        return videoInfo;
      } else if (this.isAudio) {
        return audioInfo;
      } else if (this.isFrameSequence) {
        return seqframeInfo;
      } else if (this.isModel || this.isCocosModelAnimation) {
        return modelInfo;
      }
      return [];
    },
    isPresetPrefix: function isPresetPrefix() {
      return this.resourceList && _isPresetPrefix(this.resourceList[0].prefix);
    }
  }),

  methods: _extends({}, mapActions({
    openModelEditorByGltf: 'creative/modelEditor/openModelEditorByGltf',
    replaceAnimationByGltf: 'creative/modelEditor/replaceAnimationByGltf'
  }), mapMutations({
    updateAssetsDialog: 'creative/asset/updateAssetsDialog',
    updateResourceManagerDialog: 'creative/asset/updateResourceManagerDialog',
    updateResourceUploader: 'creative/asset/updateResourceUploader',
    updateCurrentCategory: 'creative/template/updateCurrentCategory',
    updateCurrentResource: 'creative/template/updateCurrentResource'
  }), {

    uploadFile: uploadFile,

    updateUploading: function updateUploading(val) {
      this.$emit('update:uploading', val);
    },


    /**
     * @param {{file:{file_path: string, info: string, md5: string, origin_name: string, url: string}, width: number, height: number}} param0
     */
    handleUploadSuccess: function handleUploadSuccess(_ref) {
      var file = _ref.file,
          width = _ref.width,
          height = _ref.height;

      var newResource = useFileToExchangeResource({
        file: file,
        category: this.category,
        isZip: this.isZip,
        tagIds: this.model.tagIds,
        extra: _extends({}, (this.currentResource || {}).extra, {
          width: width,
          height: height
        })
      });
      this.$emit('upload-success', { resource: newResource, file: file });
    },

    // 打开裁剪对话框（抽离的公共方法）
    _openCropperDialog: function _openCropperDialog(list) {
      if (!list || !list.length || !list[0]) {
        console.error('图片列表为空或无效');
        return;
      }
      var metaData = this.fileMetaData || {};
      this.cropper = {
        img: list[0].url,
        value: list[0].id,
        outputType: 'png',
        autoCropWidth: metaData.width || 0,
        autoCropHeight: metaData.height || 0,
        fileList: list
      };
      this.cropperTitle = {
        title: this.$t('cropperDialog.xlzTitle'),
        close: this.$t('cropperDialog.button.lastStep'),
        submit: this.$t('cropperDialog.submit')
      };
      this.cropperDialogVisible = true;
    },


    // 检查图片尺寸是否匹配坑位尺寸
    _checkImageSizesMatch: function _checkImageSizesMatch(list, targetWidth, targetHeight) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var targetW, targetH, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _ref2, width, height;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                targetW = Number(targetWidth);
                targetH = Number(targetHeight);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 5;
                _iterator = _getIterator(list);

              case 7:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 19;
                  break;
                }

                item = _step.value;
                _context.next = 11;
                return getImageSize(item.url);

              case 11:
                _ref2 = _context.sent;
                width = _ref2.width;
                height = _ref2.height;

                if (!(Number(width) !== targetW || Number(height) !== targetH)) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt('return', false);

              case 16:
                _iteratorNormalCompletion = true;
                _context.next = 7;
                break;

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](5);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 25:
                _context.prev = 25;
                _context.prev = 26;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 28:
                _context.prev = 28;

                if (!_didIteratorError) {
                  _context.next = 31;
                  break;
                }

                throw _iteratorError;

              case 31:
                return _context.finish(28);

              case 32:
                return _context.finish(25);

              case 33:
                return _context.abrupt('return', true);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 21, 25, 33], [26,, 28, 32]]);
      }))();
    },
    openFrameCropperDialog: function openFrameCropperDialog(list) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var allSizeMatch;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!list || !list.length)) {
                  _context2.next = 3;
                  break;
                }

                console.error('图片列表为空');
                return _context2.abrupt('return');

              case 3:

                _this2.cropperFrames = list;

                // 如果无法获取坑位尺寸，直接走裁剪流程

                if (!(!_this2.fileMetaData || !_this2.fileMetaData.width || !_this2.fileMetaData.height)) {
                  _context2.next = 7;
                  break;
                }

                _this2._openCropperDialog(list);
                return _context2.abrupt('return');

              case 7:
                _context2.prev = 7;
                _context2.next = 10;
                return _this2._checkImageSizesMatch(list, _this2.fileMetaData.width, _this2.fileMetaData.height);

              case 10:
                allSizeMatch = _context2.sent;

                if (!allSizeMatch) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 14;
                return _this2.uploadFrameSequenceWithoutCrop(list);

              case 14:
                return _context2.abrupt('return');

              case 15:
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](7);

                console.error('检查图片尺寸失败:', _context2.t0);

              case 20:

                // 尺寸不匹配或检查失败，走裁剪流程
                _this2._openCropperDialog(list);

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 17]]);
      }))();
    },


    // 从原始 zip 提取图片并转为 base64
    _extractImagesFromZip: function _extractImagesFromZip(list) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var zip, fileNames, selectedIndices, nameList, fileDataArray, i, index, fileName, zipFile, base64;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return JSZip.loadAsync(_this3.originalZipFile);

              case 2:
                zip = _context3.sent;
                fileNames = _Object$keys(zip.files).filter(function (fileName) {
                  return !/^(__MACOSX)|(\.DS_Store)/.test(fileName) && !(zip.files[fileName] && zip.files[fileName].dir);
                }).sort(function (a, b) {
                  return Number(a.replace(/[^\d]/g, '')) - Number(b.replace(/[^\d]/g, ''));
                });
                selectedIndices = list.map(function (item) {
                  return item.id;
                }).sort(function (a, b) {
                  return a - b;
                });
                nameList = _this3.clipName(_this3.baseResourcePreviewUrls);
                fileDataArray = [];
                i = 0;

              case 8:
                if (!(i < selectedIndices.length)) {
                  _context3.next = 21;
                  break;
                }

                index = selectedIndices[i];
                fileName = fileNames[index];

                if (!fileName) {
                  _context3.next = 18;
                  break;
                }

                zipFile = zip.file(fileName);

                if (!zipFile) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 16;
                return zipFile.async('base64');

              case 16:
                base64 = _context3.sent;

                fileDataArray.push({
                  data: base64,
                  name: nameList[i] || fileName.split('/').pop() || fileName
                });

              case 18:
                i++;
                _context3.next = 8;
                break;

              case 21:
                return _context3.abrupt('return', fileDataArray);

              case 22:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },


    // 从 URL 下载图片并转为 base64
    _downloadImagesFromUrls: function _downloadImagesFromUrls(list) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var nameList, fileDataArray, _loop, i;

        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                nameList = _this4.clipName(_this4.baseResourcePreviewUrls);
                fileDataArray = [];
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
                  var item, response, blob, base64, urlParts;
                  return _regeneratorRuntime.wrap(function _loop$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          item = list[i];
                          _context4.next = 3;
                          return fetch(item.url, { cache: 'no-store' });

                        case 3:
                          response = _context4.sent;
                          _context4.next = 6;
                          return response.blob();

                        case 6:
                          blob = _context4.sent;
                          _context4.next = 9;
                          return new _Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onloadend = function () {
                              resolve(reader.result.toString().split(',')[1]);
                            };
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                          });

                        case 9:
                          base64 = _context4.sent;
                          urlParts = item.url.split('/');

                          fileDataArray.push({
                            data: base64,
                            name: nameList[i] || urlParts[urlParts.length - 1] || 'frame_' + item.id + '.png'
                          });

                        case 12:
                        case 'end':
                          return _context4.stop();
                      }
                    }
                  }, _loop, _this4);
                });
                i = 0;

              case 4:
                if (!(i < list.length)) {
                  _context5.next = 9;
                  break;
                }

                return _context5.delegateYield(_loop(i), 't0', 6);

              case 6:
                i++;
                _context5.next = 4;
                break;

              case 9:
                return _context5.abrupt('return', fileDataArray);

              case 10:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },


    // 跳过裁剪直接上传序列帧（统一入口）
    uploadFrameSequenceWithoutCrop: function uploadFrameSequenceWithoutCrop(list) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _fileDataArray, file;

        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this5.updateUploading(true);
                // 根据是否有原始 zip 文件选择不同的处理方式

                if (!_this5.originalZipFile) {
                  _context6.next = 8;
                  break;
                }

                _context6.next = 5;
                return _this5._extractImagesFromZip(list);

              case 5:
                _context6.t0 = _context6.sent;
                _context6.next = 11;
                break;

              case 8:
                _context6.next = 10;
                return _this5._downloadImagesFromUrls(list);

              case 10:
                _context6.t0 = _context6.sent;

              case 11:
                _fileDataArray = _context6.t0;
                _context6.next = 14;
                return _this5.uploadFileListDirectly(_fileDataArray);

              case 14:
                file = _context6.sent;

                _this5.handleFrameUploadSuccess(file);
                _context6.next = 24;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t1 = _context6['catch'](0);

                console.error('直接上传序列帧失败:', _context6.t1);
                _this5.$message.error('上传失败，请重试');
                _this5.updateUploading(false);
                // 失败时回退到裁剪流程
                _this5._openCropperDialog(list);

              case 24:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee5, _this5, [[0, 18]]);
      }))();
    },
    uploadFileListDirectly: function uploadFileListDirectly(fileDataArray) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var res, errorMsg;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                console.log('上传序列帧 base64 数组:', {
                  fileCount: fileDataArray.length,
                  filename: _this6.baseResourceFileName || 'frames.zip'
                });
                _context7.next = 4;
                return uploadFile({
                  file_data: _JSON$stringify(fileDataArray),
                  filename: _this6.baseResourceFileName || 'frames.zip',
                  unzip: 1,
                  wrap: 1
                });

              case 4:
                res = _context7.sent;

                console.log('上传接口响应:', res);

                if (!(res.data && res.data.code === 0)) {
                  _context7.next = 8;
                  break;
                }

                return _context7.abrupt('return', res.data.data);

              case 8:
                errorMsg = res.data && res.data.msg || '上传失败';

                console.error('上传失败:', {
                  code: res.data && res.data.code,
                  msg: errorMsg,
                  response: res
                });
                throw new Error(errorMsg);

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                console.error('uploadFileListDirectly 异常:', _context7.t0);
                throw _context7.t0;

              case 17:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee6, _this6, [[0, 13]]);
      }))();
    },
    handleFrameUploadSuccess: function handleFrameUploadSuccess(file) {
      this.cropper = {};
      this.cropperTitle = {};
      this.onSuccess({
        code: 0,
        data: file
      }, {
        response: {
          data: file
        }
      }, []);
    },
    handleBack: function handleBack() {
      if (this.cropper.fileList && this.cropper.fileList.length) {
        this.cropper = {};
        this.cropperTitle = {};
        this.frameSelectDialogVisible = true;
      }
    },
    clipName: function clipName(array) {
      var fileList = array.map(function (item) {
        var arr = item.split('/');
        return { name: arr[arr.length - 1] };
      });
      var sortedFileList = sortFileList(fileList);
      return sortedFileList.map(function (i) {
        return i.name;
      });
    },
    beforeUpload: function beforeUpload(file) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var validate, res, result, dataURL;
        return _regeneratorRuntime.wrap(function _callee7$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this7.$emit('before-upload', { file: file });

                if (!_this7.isFrameSequence) {
                  _context8.next = 23;
                  break;
                }

                _context8.next = 4;
                return _this7.validateXlzZip(file);

              case 4:
                validate = _context8.sent;

                if (validate) {
                  _context8.next = 8;
                  break;
                }

                _this7.$message.error(_this7.$t('basic.upload.sequenceFrameError'));
                return _context8.abrupt('return', _Promise.reject());

              case 8:
                // 保存原始 zip 文件，用于后续直接上传
                _this7.originalZipFile = file;
                console.log('beforeUpload: 保存原始 zip 文件', {
                  fileName: file.name,
                  fileSize: file.size,
                  originalZipFile: !!_this7.originalZipFile
                });
                // 序列帧文件处理：序列帧图片选择---》图片裁剪---》上传
                _context8.prev = 10;
                _context8.next = 13;
                return gitZipDataByFile(file);

              case 13:
                res = _context8.sent;

                _this7.cropperFrames = [];
                _this7.currentFrame = res.map(function (item, index) {
                  return { url: item, id: index };
                });
                _this7.frameSelectDialogVisible = true;
                _context8.next = 22;
                break;

              case 19:
                _context8.prev = 19;
                _context8.t0 = _context8['catch'](10);

                console.error(_context8.t0);

              case 22:
                return _context8.abrupt('return', _Promise.reject());

              case 23:
                if (!_this7.isDragonBones) {
                  _context8.next = 27;
                  break;
                }

                if (!(file.size > 1 * 1024 * 1024)) {
                  _context8.next = 27;
                  break;
                }

                _this7.$message.error(_this7.$t('playTurbo.custom.resourceUploader.warningText2'));
                return _context8.abrupt('return', _Promise.reject());

              case 27:
                if (!_this7.isVideo) {
                  _context8.next = 31;
                  break;
                }

                if (!(file.size > 3 * 1024 * 1024)) {
                  _context8.next = 31;
                  break;
                }

                _this7.$message.error(_this7.$t('playTurbo.custom.resourceUploader.videoWarningText'));
                return _context8.abrupt('return', _Promise.reject());

              case 31:
                if (!_this7.isAudio) {
                  _context8.next = 35;
                  break;
                }

                if (!(file.size > 1 * 1024 * 1024)) {
                  _context8.next = 35;
                  break;
                }

                _this7.$message.error(_this7.$t('playTurbo.custom.resourceUploader.warningText3'));
                return _context8.abrupt('return', _Promise.reject());

              case 35:
                if (!_this7.isImage) {
                  _context8.next = 57;
                  break;
                }

                if (!(file.size > 1 * 1024 * 1024)) {
                  _context8.next = 39;
                  break;
                }

                _this7.$message.error(_this7.$t('playTurbo.custom.resourceUploader.warningText4'));
                return _context8.abrupt('return', _Promise.reject());

              case 39:
                _context8.prev = 39;

                _this7.updateUploading(true);
                _context8.next = 43;
                return readFileAsDataURL(file);

              case 43:
                result = _context8.sent;
                dataURL = result.target.result;

                _this7.cropper = {
                  img: dataURL,
                  outputType: _this7.category.file_ext || ''
                };
                if (_this7.resourceMetaData) {
                  _this7.cropper = _extends({}, _this7.cropper, {
                    autoCropWidth: _this7.resourceMetaData.width,
                    autoCropHeight: _this7.resourceMetaData.height
                  });
                }
                console.log('图片上传');
                _this7.cropperDialogVisible = true;
                _this7.updateUploading(false);
                _context8.next = 56;
                break;

              case 52:
                _context8.prev = 52;
                _context8.t1 = _context8['catch'](39);

                console.error(_context8.t1);
                _this7.$message.error(_this7.$t('playTurbo.custom.resourceUploader.imgLoadFail'));

              case 56:
                return _context8.abrupt('return', _Promise.reject());

              case 57:
                _this7.updateUploading(true);
                return _context8.abrupt('return', true);

              case 59:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee7, _this7, [[10, 19], [39, 52]]);
      }))();
    },
    handleClick: function handleClick(e) {
      // 阻止事件冒泡 防止触发其他误触
      e.stopPropagation();
    },
    onChange: function onChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    onSuccess: function onSuccess(res, file, fileList) {
      this.updateUploading(false);
      this.onUploadFileSuccess(res, file, fileList);
    },
    validateXlzZip: function validateXlzZip(file) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var newFiles;
        return _regeneratorRuntime.wrap(function _callee8$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(file.size > 8 * 1024 * 1024)) {
                  _context9.next = 2;
                  break;
                }

                return _context9.abrupt('return', false);

              case 2:
                _context9.next = 4;
                return isXlzZip(file);

              case 4:
                if (_context9.sent) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt('return', false);

              case 6:
                _context9.next = 8;
                return isSameImageSizeXlz(file);

              case 8:
                if (_context9.sent) {
                  _context9.next = 10;
                  break;
                }

                return _context9.abrupt('return', false);

              case 10:
                _context9.next = 12;
                return getImageListByZip(file);

              case 12:
                newFiles = _context9.sent;

                if (!(_this8.baseResourcePreviewUrls.length > newFiles.length)) {
                  _context9.next = 15;
                  break;
                }

                return _context9.abrupt('return', false);

              case 15:
                return _context9.abrupt('return', true);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    },
    resourceValidator: function resourceValidator(_ref3) {
      var newFiles = _ref3.newFiles,
          oldFiles = _ref3.oldFiles;

      var files = newFiles;

      if (this.isFrameSequence) {
        var _validateFrameSequenc = validateFrameSequence({ files: files, oldFiles: oldFiles }),
            _validateFrameSequenc2 = _slicedToArray(_validateFrameSequenc, 2),
            valid = _validateFrameSequenc2[0],
            errors = _validateFrameSequenc2[1];

        if (!valid) this.$message.error(errors[0].message);
        return valid;
      }

      if (this.isDragonBones) {
        var _validateDragonBones = validateDragonBones({
          files: files,
          oldFiles: oldFiles,
          type: this.category.lg_type
        }),
            _validateDragonBones2 = _slicedToArray(_validateDragonBones, 2),
            _valid = _validateDragonBones2[0],
            _errors = _validateDragonBones2[1];

        if (!_valid) this.$message.error(_errors[0].message);
        return _valid;
      }

      return true;
    },
    onUploadFileSuccess: function onUploadFileSuccess(res, file, fileList) {
      var _this9 = this;

      var update = function update() {
        var newResource = _this9.cookResource(file);
        _this9.$emit('upload-success', {
          resource: newResource,
          file: res.data
        });
      };
      if (res.code === 0) {
        // 有默认资源才去校验（数据异常的场景会出现没有默认资源的情况）
        if (_.isArray(_.get(this.basicResource, 'preview_urls_for_live_preview'))) {
          var valid = this.resourceValidator({
            newFiles: _.get(file, 'response.data.files') || [],
            oldFiles: this.basicResource.preview_urls_for_live_preview
          });
          if (valid) {
            update();
          }
        } else {
          update();
        }
      } else {
        this.onError(res);
      }
    },
    onError: function onError(res) {
      this.updateUploading(false);
      this.$message({
        message: res.msg || this.$t('playTurbo.custom.resourceUploader.uploadFail'),
        type: 'warning'
      });
    },
    cookResource: function cookResource(file) {
      file = _.get(file, 'response.data');
      var newResource = useFileToExchangeResource({
        file: file,
        category: this.category,
        isZip: this.isZip,
        tagIds: this.model.tagIds
      });

      return newResource;
    },
    validate: function validate() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                if (!(_this10.category.isNeedToAddTag && (_this10.cropperDialogVisible || _this10.addAudioVisible))) {
                  _context10.next = 4;
                  break;
                }

                _context10.next = 4;
                return _this10.$refs.form.validate();

              case 4:
                return _context10.abrupt('return', true);

              case 7:
                _context10.prev = 7;
                _context10.t0 = _context10['catch'](0);

                console.error(_context10.t0);
                return _context10.abrupt('return', false);

              case 11:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee9, _this10, [[0, 7]]);
      }))();
    },
    resetTagForm: function resetTagForm(visible) {
      var _this11 = this;

      if (visible && this.category.isNeedToAddTag) {
        this.model.tagIds = this.resource ? cookTagIds(this.resource.res_tag_ids) : [];
        this.$nextTick(function () {
          _this11.$refs.form && _this11.$refs.form.clearValidate();
        });
      }
    },
    handleOpenAssetDialog: function handleOpenAssetDialog() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var DEFAULT_RULES, defaultTab, tabKeyList, maxSize, model, modelInfo;
        return _regeneratorRuntime.wrap(function _callee11$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                // 点击之前触发 before-upload
                _this12.$emit('before-upload');
                DEFAULT_RULES = {};
                defaultTab = '';
                tabKeyList = [];
                maxSize = 0;
                model = {
                  order: '-updated_time',
                  formats: _this12.fileExt.toLowerCase().split(',')
                };

                if (_this12.isImage) {
                  maxSize = 1024 * 1024;
                  model.type = 'image';
                  model.size_max = maxSize;
                  DEFAULT_RULES.image = {
                    size_max: maxSize,
                    formats: model.formats
                  };
                  defaultTab = tabNameList.commonImage;
                  tabKeyList = [tabNameList.commonImage, tabNameList.assetImage];
                }
                if (_this12.isVideo) {
                  maxSize = 3 * 1024 * 1024;
                  model.type = 'video';
                  model.size_max = maxSize;
                  DEFAULT_RULES.video = {
                    size_max: maxSize,
                    formats: model.formats
                  };
                  defaultTab = tabNameList.assetVideo;
                  tabKeyList = [tabNameList.assetVideo];
                }
                if (_this12.isAudio && _this12.category.prefix !== 'bm') {
                  maxSize = 1024 * 1024;
                  model.type = 'audio';
                  model.size_max = maxSize;
                  DEFAULT_RULES.audio = {
                    size_max: maxSize,
                    formats: model.formats
                  };
                  defaultTab = tabNameList.commonAudio;
                  tabKeyList = [tabNameList.commonAudio, tabNameList.assetAudio];
                }
                if (_this12.isAudio && _this12.category.prefix === 'bm') {
                  maxSize = 1024 * 1024;
                  model.type = 'bgm';
                  model.size_max = maxSize;
                  DEFAULT_RULES.audio = {
                    size_max: maxSize,
                    formats: model.formats
                  };
                  defaultTab = tabNameList.commonBgm;
                  tabKeyList = [tabNameList.commonBgm, tabNameList.assetAudio];
                }
                if (_this12.isFrameSequence) {
                  maxSize = 8 * 1024 * 1024;
                  model.type = 'seqframe';
                  model.size_max = maxSize;
                  model.frames = _this12.baseResourcePreviewUrls.length;
                  DEFAULT_RULES.seqframe = {
                    size_max: maxSize,
                    formats: model.formats,
                    frames: _this12.baseResourcePreviewUrls.length
                  };
                  defaultTab = tabNameList.commonFrameSequence;
                  tabKeyList = [tabNameList.commonFrameSequence, tabNameList.assetFrameSequence];
                }

                if (!(_this12.isModel || _this12.isCocosModelAnimation)) {
                  _context12.next = 24;
                  break;
                }

                _this12.updateCurrentCategory(_this12.category);
                _this12.updateCurrentResource(_this12.resource);
                _context12.next = 16;
                return getCommonAssetModelInfo({
                  name: _this12.category.prefix
                });

              case 16:
                modelInfo = _context12.sent;

                maxSize = 5 * 1024 * 1024;
                model.size_max = maxSize;
                model.skeleton_type = modelInfo.data.data.skeleton_type;
                DEFAULT_RULES.model = {
                  size_max: maxSize,
                  formats: model.formats
                };
                model.type = _this12.isCocosModelAnimation ? 'action' : 'model';
                defaultTab = _this12.isCocosModelAnimation ? tabNameList.commonAction : tabNameList.commonModel;
                if (_this12.isCocosModelAnimation) {
                  tabKeyList = [tabNameList.commonAction];
                } else if (isMaterialWarehouse()) {
                  tabKeyList = [tabNameList.commonModel];
                } else {
                  tabKeyList = [tabNameList.commonModel, tabNameList.assetModel];
                }

              case 24:
                _this12.updateResourceManagerDialog({
                  visible: true,
                  model: model,
                  defaultTab: defaultTab,
                  tabKeyList: tabKeyList
                });
                _this12.updateAssetsDialog({
                  message: _this12.fileInfo.join('<br>'),
                  model: {
                    order: model.order,
                    formats: model.formats,
                    types: [model.type]
                  },
                  rules: DEFAULT_RULES,
                  loading: false
                });
                _this12.updateResourceUploader({
                  activeRules: _this12.fileInfo,
                  accepts: model.formats,
                  maxSize: maxSize,
                  type: model.type,
                  skeleton_type: _this12.isModel ? model.skeleton_type : 0
                });
                // 因为每次触发回调事件不一样。每次都重写 callback
                assetCallbackModel.submit = function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(file) {
                    var submitCallback, res, postData, response, fileBlob, result, dataURL, _res, isGm, params, changeResourceByGltf, newFile;

                    return _regeneratorRuntime.wrap(function _callee10$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            // 提交事件执行结束的回调
                            submitCallback = function submitCallback() {
                              assetCallbackModel.loading = false;
                            };
                            // 确保多次点击不会多次触发


                            if (!assetCallbackModel.loading) {
                              _context11.next = 3;
                              break;
                            }

                            return _context11.abrupt('return');

                          case 3:
                            assetCallbackModel.loading = true;
                            _this12.updateAssetsDialog({
                              loading: true
                            });
                            if (_this12.isCocosModelAnimation) {
                              _this12.updateResourceManagerDialog({
                                visible: false
                              });
                            }
                            _context11.prev = 6;
                            res = void 0;

                            if (!(file.type === 'common')) {
                              _context11.next = 14;
                              break;
                            }

                            _context11.next = 11;
                            return getCommonComponentList({ tool: 1, id: file.file.id });

                          case 11:
                            res = _context11.sent;
                            _context11.next = 18;
                            break;

                          case 14:
                            postData = {
                              keyword: file.id,
                              search_field: 'id'
                            };
                            _context11.next = 17;
                            return assetsList(postData);

                          case 17:
                            res = _context11.sent;

                          case 18:
                            if (!(res.data && res.data && res.data.data.total === 0)) {
                              _context11.next = 23;
                              break;
                            }

                            _this12.updateAssetsDialog({
                              loading: false
                            });
                            submitCallback();
                            _this12.$message.error(_this12.$t('playTurbo.custom.resourceUploader.assetNotExist'));
                            return _context11.abrupt('return');

                          case 23:
                            _context11.next = 32;
                            break;

                          case 25:
                            _context11.prev = 25;
                            _context11.t0 = _context11['catch'](6);

                            submitCallback();
                            _this12.updateAssetsDialog({
                              loading: false
                            });
                            console.error(_context11.t0);
                            _this12.$message.error(_this12.$t('playTurbo.custom.resourceUploader.assetNotExist'));
                            return _context11.abrupt('return');

                          case 32:
                            if (!_this12.isImage) {
                              _context11.next = 60;
                              break;
                            }

                            _context11.prev = 33;
                            _context11.next = 36;
                            return fetch(file.type === 'common' ? file.file.file_url : file.full_url, {
                              // credentials: 'same-origin',
                              cache: 'no-store'
                            });

                          case 36:
                            response = _context11.sent;
                            _context11.next = 39;
                            return response.blob();

                          case 39:
                            fileBlob = _context11.sent;
                            _context11.next = 42;
                            return readFileAsDataURL(fileBlob);

                          case 42:
                            result = _context11.sent;
                            dataURL = result.target.result;

                            _this12.cropper = {
                              img: dataURL,
                              outputType: _this12.category.file_ext || ''
                            };
                            if (_this12.resourceMetaData) {
                              _this12.cropper = _extends({}, _this12.cropper, {
                                autoCropWidth: _this12.resourceMetaData.width,
                                autoCropHeight: _this12.resourceMetaData.height
                              });
                            }
                            _this12.cropperDialogVisible = true;
                            _this12.updateUploading(false);
                            _this12.updateAssetsDialog({
                              visible: false,
                              loading: false
                            });
                            submitCallback();
                            _context11.next = 58;
                            break;

                          case 52:
                            _context11.prev = 52;
                            _context11.t1 = _context11['catch'](33);

                            _this12.updateAssetsDialog({
                              loading: false
                            });
                            console.error(_context11.t1);
                            _this12.$message.error(_this12.$t('playTurbo.custom.resourceUploader.imgLoadFail'));
                            submitCallback();

                          case 58:
                            _context11.next = 72;
                            break;

                          case 60:
                            if (!_this12.isFrameSequence) {
                              _context11.next = 71;
                              break;
                            }

                            _context11.next = 63;
                            return gitZipDataByUrl(file.type === 'common' ? file.file.file_url : file.full_url);

                          case 63:
                            _res = _context11.sent;

                            _this12.cropperFrames = [];
                            _this12.currentFrame = _res.map(function (item, index) {
                              return { url: item, id: index };
                            });
                            _this12.frameSelectDialogVisible = true;

                            _this12.updateAssetsDialog({
                              visible: false,
                              loading: false
                            });
                            submitCallback();
                            _context11.next = 72;
                            break;

                          case 71:
                            if (_this12.isModel || _this12.isCocosModelAnimation) {
                              // 是否通用模板
                              // 1. 通过url参数进入带templateType页面
                              // 2. 使用通用模板制作的项目
                              // 3. 模板编辑页
                              isGm = _this12.template.isGeneralTemplateService;
                              params = {
                                fileUrl: file.file.file_url,
                                filePath: _this12.resource.real_file_path,
                                fileSource: file.type === 'asset' ? 'assets' : 'common',
                                mod: isGm ? 'gm' : 'dm',
                                model: getJsonModelPath(_this12.resourceList[0].file_path),
                                tplId: _this12.template.templateId,
                                preset: _this12.isPresetPrefix ? 1 : 0,
                                resId: file.file.id,
                                thumbUrl: file.file.thumb_url,
                                categoryId: _this12.category.id
                              };

                              if (_this12.isCocosModelAnimation) {
                                params['prefix'] = _this12.resource.prefix;
                              }
                              changeResourceByGltf = _this12.isCocosModelAnimation ? _this12.replaceAnimationByGltf : _this12.openModelEditorByGltf;


                              changeResourceByGltf(params);

                              // 关闭掉模型库弹框
                              _this12.updateResourceManagerDialog({
                                visible: false
                              });
                              submitCallback();
                            } else {
                              newFile = void 0;

                              if (file.type === 'common') {
                                newFile = useCommonToExchangeFile(file.file);
                              } else {
                                newFile = useAssetToExchangeFile(file);
                              }
                              _this12.updateAssetsDialog({
                                visible: false,
                                loading: false
                              });
                              submitCallback();
                              _this12.onSuccess({
                                code: 0,
                                data: newFile
                              }, {
                                response: {
                                  data: newFile
                                }
                              }, []);
                            }

                          case 72:
                          case 'end':
                            return _context11.stop();
                        }
                      }
                    }, _callee10, _this12, [[6, 25], [33, 52]]);
                  }));

                  return function (_x) {
                    return _ref4.apply(this, arguments);
                  };
                }();

              case 28:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee11, _this12);
      }))();
    }
  })
};